import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { Component } from '@angular/core'

@Component({
    selector: 'ca-helpdesk-dialog',
    templateUrl: './helpdesk-dialog.component.html',
    standalone: false
})
export class HelpdeskDialogComponent extends CaDialogComponent<{}, boolean> {
}